/**
 * 创建上传占位符的 DOM 元素，用于 Decoration.widget
 * 占位符为纯视觉元素，不进入 document，不会被序列化到 JSON
 */
export function createUploadPlaceholderWidget(label: string): HTMLDivElement {
    const el = document.createElement('div')
    el.className = 'upload-placeholder-widget'
    el.textContent = label
    el.style.cssText =
        'background: var(--color-gray-100); border-radius: 8px; margin: 8px; padding: 20px; text-align: center; color: var(--color-gray-500);'
    return el
}
